import { render } from "./Localidad_Empresa.vue?vue&type=template&id=f51c46b0"
import script from "./Localidad_Empresa.vue?vue&type=script&lang=js"
export * from "./Localidad_Empresa.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__